
import React, {Component, useEffect, useState} from "react";
import {Link, useLocation, useNavigate} from "react-router-dom";
import "./landingpage.css"
import {
    EmailTemplates,
    encryptData,
    formatDateAndTime,
    projectName,
    sendEmail,
    showAlert
} from "../../resources/constants";
import axios from "axios";
import {serverLink} from "../../resources/url";
import {toast} from "react-toastify";
import {
    setApplicationDetails,
    setApplicationRequirementDetails,
    setGeneralDetails,
    setLoginDetails
} from "../../actions/actions";
import {connect} from "react-redux";
import logo from "../../images/logo.png";
import banner from "../../images/banner-light.png"

function LandingPage(props) {
const location = useLocation();
 const navigate = useNavigate();
    const [formType, setFormType] = useState('Login')
    const [login, setLogin] = useState({
        EmailAddress: "",
        Password: "",
        RecoveryEmail: ""
    });

    const [dateline, setDateline] = useState([]);
    const [loading, setLoading] = useState(true);

    const getDateline = async () => {
        props.setOnApplicationDetails("");

        await axios
            .get(`${serverLink}application/dateline`)
            .then((res) => {
                setDateline(res.data.data[0]);
                setLoading(false);
            })
            .catch((err) => {
                console.log("NETWORK ERROR", err);
            });
    };

    useEffect(() => {
        getDateline();
    }, []);

    useEffect(() => {
        props.setOnLoginDetails("");
        props.setOnApplicationDetails("");
        props.setOnGeneralDetails("")
        props.setOnApplicationRequirementDetails([])
    }, [location.pathname]);

    // useEffect(() => {
    //     if (props.applicationLogin !== "")
    //         navigate("/application");
    // }, [props.applicationLogin]);

    const handleLogin = async (e) => {
        e.preventDefault();
        if (login.EmailAddress === "") {
            toast.error("Please enter your email address");
            return false;
        }

        if (login.Password === "") {
            toast.error("Please enter your password");
            return false;
        }

        await axios
            .post(`${serverLink}application/login`, login)
            .then((response) => {
                const data = response.data;
                if (data.message === "success") {
                    toast.success("Login Successful. Please wait...");
                    const dateOfBirth = data.data[0].DateOfBirth.split("T")[0];
                    const sendData = {
                        ...data.data[0],
                        DateOfBirth: dateOfBirth,
                    };
                    setTimeout(() => {
                        props.setOnLoginDetails(sendData);
                        // navigate('/application')
                        window.location.href = '/application';
                    }, 2000);
                } else toast.error("Invalid login credential!");
            })
            .catch((error) => {
                toast.error("Network error. Check your connection and try again!");
            });
    };

    const handleForgetPassword = async (e) => {
        e.preventDefault();
        toast.info("please wait...")
        const token = "pa" + Math.floor(Math.random() * 999999999);
        const email = EmailTemplates('2', encryptData(token));

        await axios.get(`${serverLink}application/registration/${login.RecoveryEmail}`, { token: encryptData(token) }).then(async (res) => {
            if (res.data.length > 0) {
                await axios.patch(`${serverLink}application/forget_password/add_token/${login.RecoveryEmail}`, { token: encryptData(token) })
                    .then((result) => {
                        if (result.data.message === "success") {
                            toast.success('An email have been sent to your mailbox, please check and proceed.')
                            sendEmail(
                                login.RecoveryEmail, email.subject, email.title, login.RecoveryEmail, email.body, '', ''
                            )
                        } else {
                            // toast.error('Please try again.')
                        }
                    }).catch((e) => {
                        console.log('NETWORK ERROR')
                    })
            } else {
                showAlert("Error", "The email provided is not registered", "error")
            }

        })

    }

    const onEdit = (e) => {
        if (e.target.id === "EmailAddress")
            setLogin({
                ...login,
                [e.target.id]: e.target.value,
            });
        else
            setLogin({
                ...login,
                [e.target.id]: encryptData(e.target.value.trim()),
            });

        if (e.target.id === "RecoveryEmail") {
            setLogin({
                ...login,
                RecoveryEmail: e.target.value
            })
        }
    };
        return (
                <>
                    {/* Main Wrapper */}
                    <div className="main-wrapper">
                        <div className="container-fuild">
                            <div className="login-wrapper w-100 overflow-hidden position-relative flex-wrap d-block vh-100">
                                <div className="row">
                                    <div className="col-lg-6">
                                        <div className="d-lg-flex align-items-center justify-content-center bg-light-300 d-lg-block d-none flex-wrap vh-100 overflowy-auto bg-01">
                                            <div>
                                                <img
                                                    src={banner}
                                                    alt="Img"
                                                />
                                                <h3 className="text-info" style={{textAlign: "center", marginTop:"-50px"}}>Qui Servit Homo, Servit Deo (Service to Man is Service to God)</h3>
                                            </div>

                                        </div>
                                    </div>
                                    {/* "assets/img/authentication/authentication-06.svg" */}
                                    <div className="col-lg-6 col-md-12 col-sm-12">
                                        <div className="row justify-content-center align-items-center vh-100 overflow-auto flex-wrap ">
                                            <div className="col-md-8 mx-auto p-4">
                                                <form onSubmit={handleLogin}>
                                                    <div>
                                                        <div className=" mx-auto mb-5 text-center">
                                                            <img
                                                                src={logo}
                                                                className="img-fluid"
                                                                alt="Logo"
                                                                width={100}
                                                            />
                                                        </div>
                                                        <div className="card">
                                                            <div className="card-body p-4">
                                                                <div className=" mb-4">
                                                                    <h2 className="mb-2 text-center">Welcome to Hensard University Admission Portal</h2>
                                                                    <p className="mb-0">
                                                                        Please enter your details to sign in
                                                                    </p>
                                                                </div>
                                                                <div className="login-or">
                                                                    {/*<span className="span-or"></span>*/}
                                                                    <hr/>
                                                                </div>
                                                                <div className="mb-3 ">
                                                                    <label className="form-label">Email Address</label>
                                                                    <div className="input-icon mb-3 position-relative">
                            <span className="input-icon-addon">
                              <i className="ti ti-mail" />
                            </span>
                                                                        <input
                                                                            type="email"
                                                                            className="form-control"
                                                                            onChange={onEdit} id="EmailAddress"
                                                                        />
                                                                    </div>
                                                                    <label className="form-label">Password</label>
                                                                    <div className="pass-group">
                                                                        <input
                                                                            type="password"
                                                                            className="pass-input form-control" onChange={onEdit} id="Password"
                                                                        />
                                                                        <span className="ti toggle-password ti-eye-off" />
                                                                    </div>
                                                                </div>
                                                                <div className="form-wrap form-wrap-checkbox mb-3">
                                                                    <div className="text-end w-100">
                                                                        <Link to="/forgot-password" className="link-danger" style={{color:"#007bff"}}>
                                                                            Forgot Password?
                                                                        </Link>

                                                                    </div>
                                                                </div>
                                                                <div className="mb-3">
                                                                    <button
                                                                        type="submit"
                                                                        className="btn btn-primary w-100"
                                                                    >
                                                                        Sign In
                                                                    </button>
                                                                </div>
                                                                <div className="text-center">
                                                                    <h6 className="fw-normal text-dark mb-0">
                                                                        Don’t have an account?{" "}
                                                                        <Link to="/register" style={{color:"#007bff"}}>
                                                                            Register
                                                                        </Link>
                                                                    </h6>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="mt-5 text-center">
                                                            <p className="mb-0 ">Copyright © {formatDateAndTime(new Date(), 'year_only')} {projectName} All Rights Reserved</p>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
        )
}
const mapStateToProps = (state) => {
    return {
        applicationLogin: state.loginDetails,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        setOnLoginDetails: (p) => {
            dispatch(setLoginDetails(p));
        },
        setOnApplicationDetails: (p) => {
            dispatch(setApplicationDetails(p));
        },
        setOnGeneralDetails: (p) => {
            dispatch(setGeneralDetails(p));
        },
        setOnApplicationRequirementDetails: (p) => {
            dispatch(setApplicationRequirementDetails(p));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(LandingPage);
